<template>
  <div id = "pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <v-toolbar
            card
            dense
            color="transparent"
            height="28px"
            class="tituloPrincipalToolbar"
          >
            <h3 class="tituloPrincipal">Tipo Jornada</h3>
          </v-toolbar>
        </v-flex>
        <v-flex xs12 sm12 md12 xl12 lg12>
          <v-card >
              <data-table
                ref="tablaJornada"
                :url="url"
                :columns="columns"
                :filters="filters"
                @setFilters="setFilters"
                :showAdvancedFilters="false"
                :perPage="[10,25,50,100]"
              >
                <tbody slot="body" slot-scope="{ data }">
                  <tr :key="item.id" v-for="item in data">
                    <td class="tipoLetra700Azul pl-4">{{item.clave}}</td>
                    <td class="tipoLetra700Azul pl-4">{{item.descripcion}}</td>
                    <td>
                      <v-tooltip bottom>
                        <v-btn slot="activator" class="botonHover" icon fab dark @click="abrirModal('update',item)" small>
                          <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                        </v-btn>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <v-btn slot="activator" class="botonHover" icon fab dark small @click="eliminar(item.id, item.descripcion)">
                          <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                        </v-btn>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </data-table>
          </v-card>    
        </v-flex>
      </v-layout>
      <v-tooltip top>        
        <v-btn dark color="info" slot="activator"  class="v-btn v-btn--bottom v-btn--floating v-btn--fixed v-btn--right theme--dark blue"
          @click="abrirModal('add')" style="transform-origin: center center 0px;background: radial-gradient(#12cbff, #05c4fe, #01C7FF 70%) !important;">
          <v-icon dark>add</v-icon>
        </v-btn>
        <span>Agregar</span>
      </v-tooltip>
    </v-container>

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-btn slot="activator" class="d-none d-lg-block" id="btnModal"></v-btn>
          <v-card>
            <v-card-title class="justify-center titulo">
              <span class="titulo" v-text="titulo_modal"></span>
            </v-card-title>
            <v-card-text>
              <div id="padre" v-show="!finaliza_carga">
                <div id="loading">
                  <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                </div>
              </div>
              <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field label="Clave" v-model="tipoJornada.clave" 
                      v-validate="'required'" data-vv-name="Clave" :error-messages="errors.collect('Clave')" >
                      <template class="pa-0 ma-0" slot="prepend-inner">
                        <v-icon class="tamIcono invertirColor">lock</v-icon>
                        <v-icon class="fa-rotate-270 pt-3 iconoDelgado">maximize</v-icon>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field label="Descripción" v-model="tipoJornada.descripcion" 
                      v-validate="'required'" data-vv-name="Descripción" :error-messages="errors.collect('Descripción')" >
                      <template class="pa-0 ma-0" slot="prepend-inner">
                        <v-icon class="tamIcono invertirColor">description</v-icon>
                        <v-icon class="fa-rotate-270 pt-3 iconoDelgado">maximize</v-icon>
                      </template>
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn class="btnGuardar" flat @click="guardar()" :loading="loading_guardar">Guardar</v-btn>
            </v-card-actions>
            <v-card-actions class="justify-center">
              <v-btn class="btnCerrar" flat @click="cerrarModal()" :disabled="loading_guardar">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import apiTipoJornada from "../api/tipoJornada";
import Datatable from '@/components/datatable/Datatable.vue';
import Notify from '@/plugins/notify';

export default {
  components: {
    'data-table': Datatable,
  },
  data(){
    return{
      url:"catalogo-sat/tipo-jornada/find",
      columns:[
        {
          label: 'Clave',
          name: 'clave',
          filterable: true
        },
        {
          label: 'Descripción',
          name: 'descripcion',
          filterable: true
        },
        {
          label: 'Opciones',
          name: 'opciones',
          filterable: false
        }
      ],
      filters:{
        activo    :true,
        paginate  :true,
      },
      advancedSearch: {
        clave          : null,
      },
      loading_guardar: false,
      loading: true,
      dialog:false,
      search: "",
      datosLogin: "",
      tipoJornada:{
        id:0,
        clave:"",
        descripcion:""
      },
      titulo_modal:"",
      finaliza_carga:false,
      action:""
    }
  },
 methods:{
  listar(){
    this.resetValues();
    this.loading = true;
    this.datosLogin = this.$session.get('usuario');
    let param = {activo:true, paginate: false};
  },
  setFilters(){
    let clave  = this.advancedSearch.clave;

    let filterParams  =  {
                          clave  :clave
                        };
    let defaultParams = {
                          activo: true,
                          paginate: true,
                        };
    if(filterParams!=null){
      Object.assign(defaultParams,filterParams);
    }
    this.filters = defaultParams;
    this.advancedSearch.nombre = null;
  },
  abrirModal(accion,item=null){
    this.errors.clear();
    this.accion = accion;
    if(accion == "add"){
      this.titulo_modal = "Registro Tipo de Jornada";
    }else{
    this.titulo_modal = "Actualizar Tipo de Jornada";
    this.tipoJornada.id           = item.id;
    this.tipoJornada.clave        = item.clave;
    this.tipoJornada.descripcion  = item.descripcion;
    }
    this.finaliza_carga = true;
    setTimeout(function(){ document.getElementById("btnModal").click(); }, 100);
  },
  guardar(){
    this.$validator.validate().then(result => {
      if (result ) {
        this.loading_guardar= true;
        if(this.accion === "add"){
          apiTipoJornada.store(this.tipoJornada)
          .then((response) => {
            this.listar();
            this.$refs.tablaJornada.getData();
            this.respuesta_ok();
          })
          .catch(err => {
            this.respuesta_error(err);
          });
        }
        else if(this.accion === "update"){
          apiTipoJornada.update(this.tipoJornada)
          .then((response) => {
            this.listar();
            this.$refs.tablaJornada.getData();
            this.respuesta_ok();
            
          })
          .catch(err => {
            this.respuesta_error(err);
          });
        }
      }
    });
  },
  cerrarModal(){
    this.dialog = false;
    this.resetValues();
  },
  resetValues(){
    this.tipoJornada.id = 0;
    this.tipoJornada.clave = "";
    this.tipoJornada.descripcion = "";
    this.loading_guardar= false;
  },
  eliminar(id, jornadaTipo){
    let self = this;
    Notify.Alert(
      "¡Hey! ¿Estás seguro?",
      "¿Estás seguro que deseas eliminar el tipo de jornada " + jornadaTipo + "?",
      "SI! QUIERO ELIMINARLO",
      () => {
        apiTipoJornada.delete(id).then((response)=>{
          self.listar();
          self.$refs.tablaJornada.getData();
          Notify.Success("Tipo de Jornada eliminado", "El tipo de jornada ha sido eliminado satisfactoriamente");
        })
        .catch(err => {
          console.log(err);
          Notify.ErrorToast(err.response.data.error);
        });
      }
    )
  },

  respuesta_error(error){
      console.log(error.response.data.error);
      this.loading_guardar= false;
      Swal.fire({
        position: 'center',
        type: 'error',
        title: "Error",
        text: error.response.data.error,
        showConfirmButton: true,
      }) 
    },
  respuesta_ok(){
    this.cerrarModal();
    Swal.fire({
      position: 'center',
      type: 'success',
      title: "Operación exitosa",
      showConfirmButton: true,
    }) 
  }

 },
  created() {
    this.listar();
  },

}
</script>

<style scoped>
  #padre {
    padding-left: 40%;
  }
  #loading{
    display: table-cell;
    vertical-align: middle;
  }
  .margen_superior{
    margin-top: -3% !important;
  }
  #contenedor{
    margin-top: -6%;
  }
  .titulo{
    font-family: 'Montserrat' !important;
    font-size: 28px !important;
    font-weight: 700 !important;
    color: #0f3043 !important;
    letter-spacing: -0.68px;
    line-height: 34px;
  }
  .btnGuardar{
    font-family: 'Montserrat';
    font-size: 13px !important;
    font-weight: 700 !important;
    background-color: #183799 !important;
    border-radius: 23px 23px 23px 23px;
    color: white !important;
    width: 70% !important;
    height: 40px !important;
  }
  .btnCerrar{
    font-family: 'Montserrat';
    font-size: 13px !important;
    font-weight: 700 !important;
    background-color: white !important;
    border-radius: 23px 23px 23px 23px;
    color: rgba(121, 141, 152, 0.6);
    width: 70% !important;
    height: 40px !important;
  }
  .estiloLetras{
    font-family: 'Montserrat';
    font-weight: 400 !important;
    color: #8A8FB4 !important;
    font-size: 13px !important;
    line-height: 16px;
    margin: 0%;
    padding: 0%;
  }
  .invertirColor{
    color: white;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: rgba(0,0,0,0.54);
  }
  .tamIcono{
    height: 24px !important;
    align-self: center !important;
  }
  .iconoDelgado{
    color: white;
    -webkit-text-stroke-width: 1px;
    -webkit-text-fill-color: rgba(0,0,0,0.54);
  }
  .tituloPrincipalToolbar{
    border-left-style: solid; 
    border-left-color: #5e87fe !important;
  }
  .tituloPrincipal{
    color: #05283B;
    font-family: 'Montserrat';
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.1px;
    line-height: 26px;
    text-align: left;
  }
  .tipoLetra700Azul{
    font-weight: 700;
    letter-spacing: -0.34px;
  }
</style>